import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout.vue'
import Events from '@/views/Events.vue'
import OriginList from '@/views/OriginList.vue'
import Login from '@/views/Login.vue'

Vue.use(Router)

// Navigation guard to check authentication
const requireAuth = (to, from, next) => {
  // Check if user is authenticated
  const isAuthenticated = !!localStorage.getItem('user')
  
  if (!isAuthenticated && to.path !== '/login') {
    // Before redirect, check authentication status
    import('./store').then(storeModule => {
      const store = storeModule.default
      store.dispatch('checkAuthStatus')
        .then(status => {
          if (status.authenticated) {
            next()
          } else {
            next('/login')
          }
        })
        .catch(() => {
          next('/login')
        })
    })
  } else if (isAuthenticated && to.path === '/login') {
    next('/')
  } else {
    next()
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'all',
      component: OriginList,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/origin/:serverOrigin',
      props: true,
      component: Layout,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/user/:userEmail',
          name: 'byUserEmail',
          props: true,
          component: Events
        },
        {
          path: '',
          name: 'origin',
          props: true,
          component: Events
        },
        {
          path: 'session/:sessionId',
          name: 'session',
          props: true,
          component: Events
        }
      ]
    }
  ]
})
